var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgXlogsX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 39,
    viewBox: "0 0 31 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5992 17.5213L16.4888 13.041L30.5767 0V4.38159L16.5992 17.5213Z",
    fill: "#4B4B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5931 24.6928L14.4625 20.3596L30.5735 5.16583V9.94557L14.5931 24.6928Z",
    fill: "#4B4B4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0189 25.3657L13.8256 20.9348L0.0344238 33.764V38.2315L14.0189 25.3657Z",
    fill: "#4B4B4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0045 18.1049L15.8957 13.6533L0.0143204 28.4665C0.0143204 28.4665 -0.0179004 33.1229 0.0143204 33.0877C0.0465412 33.0525 16.0045 18.1049 16.0045 18.1049Z",
    fill: "#4B4B4B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29926 12.8441V7.90405L12.1621 16.2532L9.4067 18.8471L3.29926 12.8441Z",
    fill: "#4B4B4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31691 7.19271L3.31689 2.19086L15.2778 13.3921L12.525 15.945L3.31691 7.19271Z",
    fill: "#4B4B4B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0742 26.5236V31.6161L18.3688 22.2976L21.1744 19.7653L28.0742 26.5236Z",
    fill: "#4B4B4B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9564 32.3034V37.2435L15.11 25.0873L17.9122 22.5958L27.9564 32.3034Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlogsX);
export default __webpack_public_path__ + "static/media/xlogs_X.61cb8319866d1183b57d12b79dc18454.svg";
export { ForwardRef as ReactComponent };